import { useState, useEffect, useMemo } from 'react'

export function useSearch<T>(
  data: T[],
  searchFields: (keyof T)[],
  delay = 300,
) {
  const [searchTerm, setSearchTerm] = useState('')
  const [debouncedTerm, setDebouncedTerm] = useState('')
  const [isSearching, setIsSearching] = useState(false)

  useEffect(() => {
    setIsSearching(true)
    const timer = setTimeout(() => {
      setDebouncedTerm(searchTerm)
      setIsSearching(false)
    }, delay)

    return () => clearTimeout(timer)
  }, [searchTerm, delay])

  const filteredData = useMemo(() => {
    if (!debouncedTerm) return data

    return data.filter((item) =>
      searchFields.some((field) => {
        const value = item[field]
        if (value === null || value === undefined) return false
        return String(value).toLowerCase().includes(debouncedTerm.toLowerCase())
      }),
    )
  }, [data, debouncedTerm, searchFields])

  return {
    searchTerm,
    setSearchTerm,
    filteredData,
    isSearching,
  }
}
